export const PAYMENT_TERMS_TYPE_KEY = "payment";

export function isAlreadyAcceptedConflict(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    (error as { response?: { status?: number } }).response?.status === 409
  );
}

export async function recordPaymentTermsAcceptance(options: {
  accept: (
    versionId: string,
    payload: { organizationId: string; accepted: boolean },
  ) => Promise<unknown>;
  organizationId: string;
  versionId: string;
  alreadyAccepted?: boolean;
}): Promise<void> {
  if (
    options.alreadyAccepted ||
    !options.versionId ||
    !options.organizationId
  ) {
    return;
  }
  try {
    await options.accept(options.versionId, {
      organizationId: options.organizationId,
      accepted: true,
    });
  } catch (error) {
    if (isAlreadyAcceptedConflict(error)) {
      return;
    }
    throw error;
  }
}
